// v0.6 — JS mirror of backend/engine/calc_request.py::normalize_period_fx_rates.
// Canonicalizes a REHYDRATED period_fx_rates value into
// {TARGET: {SOURCE: "rate"}}, TARGET in {"GBP", "EUR"} — the only two
// values engine/calc_row_rules.py::_row_filing_base can ever produce
// through the flat-rate (non-national-bucket) path. See that function's
// docstring for the full two-target rationale.
//
// Used only when REHYDRATING a value the backend already validated (a
// persisted calc doc) — outbound request validation is owned entirely
// by the backend's own normalize_period_fx_rates, not duplicated here.
export const normalizePeriodFxRates = (raw, regime) => {
  if (!raw || typeof raw !== "object" || Object.keys(raw).length === 0) {
    return {};
  }
  const values = Object.values(raw);
  const isNested = values.every((v) => v && typeof v === "object");
  const isFlat = values.every((v) => !(v && typeof v === "object"));
  if (!isNested && !isFlat) return {}; // malformed — never propagate garbage

  const wrapped = isFlat
    ? { [regime === "UK_VAT" ? "GBP" : "EUR"]: raw }
    : raw;

  const out = {};
  for (const [tgt, srcs] of Object.entries(wrapped)) {
    const tgtCode = String(tgt).toUpperCase();
    if (tgtCode !== "GBP" && tgtCode !== "EUR") continue;
    const inner = {};
    for (const [src, rate] of Object.entries(srcs || {})) {
      const srcCode = String(src).toUpperCase();
      if (srcCode === tgtCode) continue; // same-currency no-op
      inner[srcCode] = String(rate);
    }
    if (Object.keys(inner).length) out[tgtCode] = inner;
  }
  return out;
};

// True when `value` already looks like the canonical nested shape
// (every top-level value is itself an object) — used by the
// localStorage rehydration path, which has no `regime` to infer a
// legacy flat value's target from.
export const looksLikeNestedPeriodFxRates = (value) => {
  if (!value || typeof value !== "object") return false;
  const values = Object.values(value);
  return values.length === 0 || values.every((v) => v && typeof v === "object");
};
